/** @module utils/determineHasCreatedEventRates */

/**
 * Parameters for determining whether event rates have been created.
 */
interface DetermineHasCreatedEventRatesParams {
    filteredFacilities: Array<{
        hasCreatedEventRates?: boolean;
    }>;
}

/**
 * Determines whether at least one facility in a set has created event rates.
 *
 * @param {DetermineHasCreatedEventRatesParams} params - The input parameters.
 * @returns {boolean} Whether at least one facility has created event rates.
 */
const determineHasCreatedEventRates = ({
    filteredFacilities,
}: DetermineHasCreatedEventRatesParams): boolean =>
    filteredFacilities.some(
        (facility) => facility.hasCreatedEventRates === true
    );

export default determineHasCreatedEventRates;
